import { Injectable } from '@angular/core';
import { Catalog, Parameter, StringHelper, UrlHelperService, UrlPathHelperService } from '@lobos/library';
import { TranslocoService } from '@ngneat/transloco';
import { NavigationInterface } from '../../interfaces/navigation.interface';
import { sortBy } from 'lodash';
import { ID } from '@datorama/akita';

@Injectable({
  providedIn: 'root',
})
export class CatalogHelperService {
  constructor(private translocoService: TranslocoService, private urlHelper: UrlHelperService) {}

  public localizedUrlPath(params: Parameter, path: string, language: string): string {
    const catalogName = this.urlHelper.normalize(params.sCatalogName);
    const urlPath = StringHelper.trim(path.replace(catalogName, language), '/');
    return `/${urlPath}`;
  }

  public buildNavigationFromAll(params: Parameter, catalog: Catalog[]): NavigationInterface[] {
    const parents: { [key: ID]: Catalog[] } = {};
    for (const group of catalog) {
      if (!parents[group.lngParentGroup]) {
        parents[group.lngParentGroup] = [];
      }
      parents[group.lngParentGroup].push(group);
    }

    const root: Catalog | undefined = catalog.find((group: Catalog) => group.lngGroup === params.lngProductRootGroup);
    if (!root) {
      return [];
    }

    return this.mapGroupToNav([root], parents);
  }

  private getGroupsForParent(parentId: ID, parents: { [key: ID]: Catalog[] }): NavigationInterface[] {
    const group: Catalog[] = parents[parentId] || [];

    return this.mapGroupToNav(sortBy(group, 'lngItemId'), parents);
  }

  private mapGroupToNav(catalog: Catalog[], parents: { [key: ID]: Catalog[] }): NavigationInterface[] {
    return catalog.map((group: Catalog) => ({
      title: group.sTitle,
      url: this.getCatalogUrlPath(group),
      subNavigation: this.getGroupsForParent(group.lngGroup as number, parents),
    }));
  }

  private getCatalogUrlPath(category: Catalog) {
    return UrlPathHelperService.getUrlPath(category?.sUrlPath, this.translocoService.getActiveLang());
  }
}
